import { Col, Row, Typography } from 'antd'
import React from 'react'
import IconRatingSkill from '../../../common/iconRating'
import icoSkills from '../../../images/candidateCard/ico_skills.png'
import './index.css'
import { DICTIONARY } from '../../../utilities/dictionary'
import { useLocation } from 'react-router-dom'
const { Text } = Typography;

interface Props {
    skills: Array<any>
}
const SkillsSection: React.FC<Props> = ({ skills }) => {
    const location = useLocation();
    return (
        <>
            <Row className='container-subsection-skill-titles-section'>
                <Col style={{ paddingLeft: 10, paddingRight: 40 }}>
                    <img
                        src={icoSkills}
                        style={{ height: 40, width: 40 }}
                        alt={icoSkills}
                    />
                </Col>

                <Col style={{ display: 'flex', alignItems: 'center', height: '100%' }}>
                    <Text style={{ color: "#129BD4", fontSize: 24 }}>
                        {DICTIONARY['profile_text_skills'][location.pathname.split('/')[1] === 'en' ? 'English' : 'French']}
                    </Text>
                </Col>
            </Row>

            <Row className='container-group-skills'>
                {skills.length > 0 ? (
                    skills.map((skill) => (
                        <Col key={skill.level + skill.name} style={{ padding: 1, height: 30, marginRight: 40, marginBottom: 20 }}>
                            <Row style={{ width: '100%', display: 'flex', alignItems: 'center' }}>
                                <Col style={{ display: 'flex', alignItems: 'center' }}>
                                    <div style={{ width: '100%', display: 'flex', alignItems: 'center' }}>
                                        <IconRatingSkill rating={skill.level} />
                                    </div>
                                </Col>

                                <Col style={{ display: 'flex', alignItems: 'center', paddingLeft: 5 }}>
                                    <Text style={{ fontSize: 20 }}>{skill.name}</Text>
                                </Col>
                            </Row>
                        </Col>
                    ))
                ) : (
                    <div style={{ height: '100%', width: '100%', justifyContent: 'center', alignItems: 'center', display: 'flex' }}>
                        <Text style={{ color: '#00000040', fontSize: 30 }}>No skills</Text>
                    </div>
                )}
            </Row>

        </>
    )
}

export default SkillsSection
